import { LOCALES_CODES } from './types';

export const defaultLocale = LOCALES_CODES.enum.en;

const localeDefinition = (code: LOCALES_CODES, name: string) => ({
  sys: {
    type: 'Locale',
    id: code,
  },
  code,
  name,
  fallbackCode: code !== defaultLocale ? defaultLocale : null,
  default: code === defaultLocale,
  contentManagementApi: true,
  contentDeliveryApi: true,
  optional: code !== defaultLocale,
});

export const locales = [
  localeDefinition(LOCALES_CODES.enum.en, 'English'),
  localeDefinition(LOCALES_CODES.enum.es, 'Spanish'),
  localeDefinition(LOCALES_CODES.enum.ko, 'Korean'),
];
